const DownloadStream = {
  methods: {
    downloadStream(stream, fileName = 'File', fileExtension = 'txt') {
      const el = document.createElement('a');
      el.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(stream)}`);
      el.setAttribute('download', `${fileName}.${fileExtension}`);
      el.style.display = 'none';

      document.body.appendChild(el);
      el.click();
      document.body.removeChild(el);
    },
  },
};

export default DownloadStream;
